// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutConfines_wrapper__9yCbF","extra":"LayoutConfines_extra__gyZwP"};